module.exports = __webpack_public_path__ + "static/media/skill_angular.1a632d2b.png";